import { Typography } from '@kizen/kds/Typography';
import { AssistantField } from '@kizenapps/engine';
import { getLinkValue } from '@kizenapps/engine/util';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getParamFromAuth } from './util';

export const LinkBlock = ({ field }: { field: AssistantField }) => {
  const auth = useSelector((state: any) => state.authentication);

  const linkValue = useMemo(() => {
    const val = getLinkValue(field.href, field.include, getParamFromAuth(auth));

    return val;
  }, [auth, field.href, field.include]);

  return (
    <div>
      <Typography
        variant="link"
        href={linkValue}
        target="_blank"
        rel="noopener noreferrer"
      >
        {field.text}
      </Typography>
    </div>
  );
};
